import React, { useEffect, useRef, useState } from 'react';
import { serviceMenuItems, ServiceMenuIcon } from './serviceMenuData';
import FadeInAnimation from '../home_page/homeComponents/FadeInAnimation';
import {Link, withRouter} from 'react-router-dom';
import { NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';

import { NAV_IMAGES } from '../../../../assets/images/landing';
import { NAVBAR_MOBILE } from '../../../../assets/images/navbar';
import {
  NavBarContainer,
  UpperNavRow,
  NavRow,
  NavColFirst,
  NavColSecond,
  NavBarImage,
  NavbarMenuImageWrapper,
  NavMenuImage,
  NavMenu,
  NavbarMenuCloseImageWrapper,
  MenuOptions,
  ArrowIcon,
  BottomRow,
  LoginButton,
  SignUpButton,
  ServicesOptions,
  ServicesOptionsList,
  ServicesOptionsListItem,
  TopRightWave
} from './styles/MobileLoggedOutNavbarStyles';
import { ROUTES } from '../../routes';

const NavbarLoggedOutMobile = (props) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const menuTrigger = useRef(null);
  const menuClose = useRef(null);

  const [isServiceDropDownOpen, setServiceDropDownOpen] = useState(false);

  const updateMenu = () => {
    setMenuOpen(true);
    document.body.classList.add('hideAllOverFlow');
    document.getElementById('root').classList.add('hideAllOverFlow');
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setServiceDropDownOpen(false);
    document.body.classList.remove('hideAllOverFlow');
    document.getElementById('root').classList.remove('hideAllOverFlow');
  };

  useEffect(() => { closeMenu(); }, [props.location.pathname]);
  useEffect(() => () => {
    document.body.classList.remove('hideAllOverFlow');
    document.getElementById('root').classList.remove('hideAllOverFlow');
  }, []);

  useEffect(() => {
    if (!isMenuOpen) return;
    menuClose.current.focus();
    const keepFocusInMenu = event => {
      if (event.key !== 'Tab') return;
      const links = Array.from(document.getElementById('mobile-navigation').querySelectorAll('a[href], button:not([disabled])')).filter(element => element.getClientRects().length > 0);
      const first = links[0];
      const last = links[links.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', keepFocusInMenu);
    return () => document.removeEventListener('keydown', keepFocusInMenu);
  }, [isMenuOpen]);

  let bottomRow = <BottomRow className='bottomRow'>
    <Link to={'/login'}>
      <LoginButton className='loginButton'>Log In</LoginButton>
    </Link>
    <div
      onClick={() => { props.setModal(true); closeMenu() }}>
      <SignUpButton>Schedule Shoot</SignUpButton>
    </div>
  </BottomRow>

  if (props.currentUser){
    bottomRow = <BottomRow className='bottomRow'>
      <Link to={'/dashboard'}>
        <SignUpButton>Dashboard</SignUpButton>
      </Link>
    </BottomRow>
  }

  return (
    <FadeInAnimation inView={true} yOffset={-12} duration={0.5} delaySeconds={0}><NavBarContainer>
      {props.nonAppPage && !props.disableWaveBackground && <TopRightWave />}
      <UpperNavRow>
        <NavColFirst>
          <Link to="/" className="navbar-brand">
            <NavBarImage src={NAV_IMAGES.WebLogo} alt='' />
          </Link>
        </NavColFirst>
        <NavColSecond>
          <NavbarMenuImageWrapper type="button" ref={menuTrigger} onClick={updateMenu} className="navbarMenuImageWrapper" aria-label="Open navigation" aria-expanded={isMenuOpen} aria-controls="mobile-navigation">
            <NavMenuImage src={NAV_IMAGES.HeaderMenu} alt='' />
          </NavbarMenuImageWrapper>
        </NavColSecond>
      </UpperNavRow>
      <NavMenu id="mobile-navigation" aria-hidden={!isMenuOpen} inert={!isMenuOpen ? '' : undefined} className={isMenuOpen ? 'showNavMenu' : ''} onKeyDown={event => { if (event.key === 'Escape') { closeMenu(); menuTrigger.current.focus(); } }}>
        <NavRow>
          <NavColFirst>
            <Link to="/" className="navbar-brand">
              <NavBarImage src={NAV_IMAGES.MOBILE_LOGOUT_LOGO} alt='' />
            </Link>
          </NavColFirst>
          <NavColSecond>
            <NavbarMenuCloseImageWrapper ref={menuClose} type="button" onClick={() => { closeMenu(); menuTrigger.current.focus(); }} aria-label="Close navigation">
              <NavMenuImage src={NAV_IMAGES.MOBILE_LOGOUT_CROSS} alt='' />
            </NavbarMenuCloseImageWrapper>
          </NavColSecond>
        </NavRow>
        <MenuOptions className={`${isServiceDropDownOpen ? 'serviceOpen' : ''}`}>
          <Nav className='mr-auto' navbar>
            <NavItem>
              <button type="button" className="nav-link rightArrowWrapper services-toggle" aria-expanded={isServiceDropDownOpen} aria-controls="mobile-services" onClick={() => setServiceDropDownOpen(!isServiceDropDownOpen)}>Services<ArrowIcon className={isServiceDropDownOpen ? 'arrowIcon' : ''} src={NAVBAR_MOBILE.NavBarMobileArrow} alt="" /></button>
              <ServicesOptions id="mobile-services" hidden={!isServiceDropDownOpen}>
                <ServicesOptionsList>{serviceMenuItems.map(service => <ServicesOptionsListItem key={service.to}><Link to={service.to} onClick={closeMenu} aria-current={props.location.pathname === service.to ? 'page' : undefined}><span className="mobile-service-icon"><ServiceMenuIcon type={service.icon}/></span><span><strong>{service.title}</strong><span className="mobile-service-description">{service.description}</span></span></Link></ServicesOptionsListItem>)}</ServicesOptionsList>
              </ServicesOptions>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to={ROUTES.ABOUT}>About Us</NavLink>
              {/* <NavLink href='/about'>About Us</NavLink> */}
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to={ROUTES.BLOG_INDEX}>Blog</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to={ROUTES.LOCATIONS}>Coverage</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} to={ROUTES.CAREERS}>Careers</NavLink>
              {/* <NavLink href='/about'>About Us</NavLink> */}
            </NavItem>
            {/* <NavItem>
              <NavLink href='#'>Case Studies</NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink tag={Link} to={ROUTES.CONTACTS}>Contact</NavLink>
              {/* <NavLink href='/contacts'>Contact</NavLink> */}
            </NavItem>
          </Nav>
          {bottomRow}
        </MenuOptions>
      </NavMenu>
    </NavBarContainer></FadeInAnimation>
  );
};

export default withRouter(NavbarLoggedOutMobile);
